<template>
  <div class="viewDetial" v-if="hackReset">
    <!-- 订单详情弹框 -->
    <a-modal title="订单详情" :width="900" :visible="visible" :footer="null" @cancel="handleCancel" :maskClosable="false">
      <div class="viewDetial-tiem">
        <div class="viewDetial-tiem">
        <a-row style="height:30px">
          <a-col :span="12">
            <label>预约人： <span style="color:black">{{ this.record.patientname }}</span></label>
          </a-col>
          <a-col :span="12">
            <label>金额：<a>{{ this.record.price }}</a>元 </label>
          </a-col>
        </a-row>
        <a-row style="height:30px">
          <a-col :span="12">
            <label>手机号： {{ this.record.mobile }} </label>
          </a-col>
          <a-col :span="12">
            <label>订单状态：{{ this.record.status == '1' ? '待支付' : this.record.status == '2' ? '待体检' : this.record.status == '3' ? '已完成' : this.record.status == '4' ? '已取消' : '' }}</label>
          </a-col>
        </a-row>
        <a-row style="height:30px">
          <a-col :span="12">
            <label>身份证号：{{ this.record.cardno.substr(0,2) + '***************' + this.record.cardno.substr(16, 18) }}</label>
          </a-col>
          <a-col :span="12">
            <label>提交时间： {{ this.record.ctstamp }}</label>
          </a-col>
        </a-row>
      </div>
        <div>
          <s-table ref="tables" :columns="columns" :data="loadData" :rowKey="(record) => record.projectNum">


          </s-table>
        </div>
      </div>
    </a-modal>
  </div>

</template>

<script>
import { STable , XDown } from '@/components'
import { recipeDetial } from '@/api/modular/interhospital/subExamination/subExamination'
export default {
  components:{
    STable,XDown
  },
	data() {
		return {
      parameter : {},

			labelCol: {
				xs: { span: 24 },
				sm: { span: 5 },
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 15 },
			},
			ctstampDateString: '',
			visible: false,
      deliver : false,
      logisticsChange : false,
      userDate : '',
      record : '',
      loadData: parameter => {
          return new Promise(async(resolve,reject)=>{
            const res = await recipeDetial(Object.assign(parameter, this.parameter));
            resolve(res.data)
          })
        },
      // 表头
        columns: [
          {
            title: '创建时间',
            align: 'center',
            dataIndex: 'createTime'
          },
          {
            title: '套餐编号',
            align: 'center',
            dataIndex: 'projectNum'
          },
          {
            title: '检查科室',
            align: 'center',
            dataIndex: 'departmentName'
          },
          {
            title: '套餐名称',
            align: 'center',
            dataIndex: 'projectName'
          },  
          {
            title: '性别限定',
            align: 'center',
            dataIndex: 'gender'
          },  
          {
            title: '金额（元）',
            align: 'center',
            dataIndex: 'projectPrice'
          }, 
        ],
        hackReset : true,
		}
	},
  created(){
    this.initMap();
  },
  
	methods: {
		// 初始化方法
		add(record) {
      console.log(record)
      this.record = record;
      if( record.bookingId !=  this.parameter.bookingId ){
        this.parameter.bookingId = record.bookingId;
      }
			this.visible = true;
      
		},

		onChangectstamp(date, dateString) {
			this.ctstampDateString = dateString
		},
    // 点击提交物流信息
    handleSubmit(){

    },
    // 关闭页面的时候通过v-if重组页面，防止组件缓存不调用接口
		handleCancel() {
			this.visible = false;
      this.hackReset = false;
      this.$nextTick(()=>{
        this.hackReset = true;
      })
		},
    // 点击切换发货
    changeModel(){
      this.visible = false;
      this.deliver = true;
    },
    // 点击物流信息
    changeLogistics(){
      this.visible = false;
      this.logisticsChange = true;
    },
    deliverHandleCancel(){
      this.deliver = false;
      this.visible = true;
    },
    logisticsHandleCancel(){
      this.logisticsChange = false;
    },
    // 搜索物流信息
    onSearch(){
      console.log('搜索')
    },
    // 初始化地图
    initMap() {
      let map = new AMap.Map("MapContainer", {
        zoomEnable: true, //是否禁止缩放
        zoom: 12, //缩放比例
        dragEnable: false, //禁止拖动
        cursor: "hand" // 鼠标在地图上的表现形式，小手
      });
      // 初始化工具条
      map.plugin(["AMap.ToolBar"], function() {
        map.addControl(new AMap.ToolBar());
      });
    }
	},
}
</script>

<style lang="less" scoped>
.viewDetial-tiem{
  margin-bottom: 10px;
}
.viewDetial-header{
  display: flex;
  .viewDetial-title{
    flex: 7;
  }
  .viewDetial-btn{
    flex: 3;
    padding: 4px 0;
  }
}
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
  .viewDetial-title-notes{
    font-weight: 400;
    font-size: 13px;
    color: rgba(127, 127, 127, 0.847058823529412);
    margin-left: 15px;
  }
}
.viewDetial-tiem-type{
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  color: rgb(51, 51, 51);
  background-color: #d7d7d7;
  padding: 0 20px;
  border-radius: 5px;
  
}
/deep/.s-table-tool{
  display: none;
}
.viewDetial-logistics{
  display: flex;

  .viewDetial-logistics-item{
    flex: 1;
    width: 290px;
    max-width: 290px;
  }

  .viewDetial-logistics-map{
    flex: 1;

    #MapContainer{
      height: 310px;
      width: 100%;
    }
  }

}
.totalPrice{
  line-height: 30px;
  padding: 0 15px 0 30px;
}
</style>
